import { createSelector } from '@ngrx/store';
import { getIncomeNetWorthState } from '@store/reducers';

export const selectAnnualIncome = createSelector(
  getIncomeNetWorthState,
  (state) => state.annualIncome,
);

export const selectLiquidNetWorth = createSelector(
  getIncomeNetWorthState,
  (state) => state.liquidNetWorth,
);

export const selectValidationStatus = createSelector(
  getIncomeNetWorthState,
  (state) => state.validationStatus,
);

export const selectIncomeNetWorth = createSelector(
  selectAnnualIncome,
  selectLiquidNetWorth,
  (annualIncome, liquidNetWorth) => ({
    annualIncome,
    liquidNetWorth,
  }),
);
